var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            { staticClass: "selectClass" },
            [
              _c(
                "el-row",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.postalCodeState"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getCity(_vm.queryForm.params.state)
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "state", $$v)
                                },
                                expression: "queryForm.params.state",
                              },
                            },
                            _vm._l(_vm.twoCodeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.stateCode,
                                  value: item.stateCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.postalCodeCity"),
                          },
                        },
                        [
                          _c("ElSelectV2", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.allCity,
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "city", $$v)
                              },
                              expression: "queryForm.params.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.Zip") } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              clearable: "",
                              placeholder: _vm.$t(
                                "collectionCenter.input8ZipCode"
                              ),
                            },
                            model: {
                              value: _vm.queryForm.params.zipCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "zipCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryForm.params.zipCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.regionType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.areaType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "areaType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.areaType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "Capital", value: "Capital" },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Metropolitana",
                                  value: "Metropolitana",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Interior 0",
                                  value: "Interior 0",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Interior 1",
                                  value: "Interior 1",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Interior 2",
                                  value: "Interior 2",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "Interior 3",
                                  value: "Interior 3",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.search },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info", size: "small" },
                          on: { click: _vm.reset },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.reset")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", [_c("el-divider")], 1),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:basic-data:postal-code-management:add",
                      expression: "'btn:basic-data:postal-code-management:add'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    icon: "el-icon-plus",
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.newAdd },
                },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.add")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:basic-data:postal-code-management:import",
                      expression:
                        "'btn:basic-data:postal-code-management:import'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.importThis },
                },
                [_vm._v(" " + _vm._s(_vm.$t("collectionCenter.Import")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:basic-data:postal-code-management:allExport",
                      expression:
                        "'btn:basic-data:postal-code-management:allExport'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.exportAll },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("collectionCenter.allExport")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              attrs: { border: "", data: _vm.tableDate, "max-height": 600 },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("mdfeTranslate.Serial"),
                  type: "index",
                  width: "60",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "state",
                  align: "center",
                  label: _vm.$t("mdfeTranslate.StateUF"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "city",
                  align: "center",
                  label: _vm.$t("collectionCenter.city"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "startZipCodeStr",
                  align: "center",
                  label: _vm.$t("mdfeTranslate.StartZipCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "endZipCodeStr",
                  align: "center",
                  label: _vm.$t("mdfeTranslate.EndZipCode"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "areaType",
                  align: "center",
                  label: _vm.$t("collectionCenter.regionType"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "riskAreaDesc",
                  align: "center",
                  label: _vm.$t("basicData.RiskAreas"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "covered",
                  align: "center",
                  label: _vm.$t("collectionCenter.IsOverride"),
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "ibge", align: "center", label: "IBGE" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.LatestModifiedBy"),
                  prop: "updateUserName",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.LastModified"),
                  prop: "updateTime",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.edit"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:basic-data:postal-code-management:edit",
                                    expression:
                                      "'btn:basic-data:postal-code-management:edit'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: {
                                  color: "#666",
                                  "margin-right": "10px",
                                },
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-edit-outline",
                                  staticStyle: { "font-size": "20px" },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.Delete"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-popconfirm",
                              {
                                attrs: {
                                  title: _vm.$t("collectionCenter.deleteSure"),
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.tableDel(scope.row.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:basic-data:postal-code-management:del",
                                      expression:
                                        "'btn:basic-data:postal-code-management:del'",
                                      arg: "remove",
                                    },
                                  ],
                                  staticClass: "el-icon-delete",
                                  staticStyle: { "font-size": "20px" },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.search,
                  "size-change": _vm.search1,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogIsOpen,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "5%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogIsOpen = $event
            },
            close: _vm.cloceDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "addPostCon",
              attrs: { model: _vm.postalCodeList, size: "small" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.StateUF"),
                            prop: "state",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getEditCity(
                                    _vm.postalCodeList.state
                                  )
                                },
                              },
                              model: {
                                value: _vm.postalCodeList.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.postalCodeList, "state", $$v)
                                },
                                expression: "postalCodeList.state",
                              },
                            },
                            _vm._l(_vm.twoCodeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.stateCode,
                                  value: item.stateCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.city"),
                            prop: "city",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("ElSelectV2", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.allEditCity,
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              filterable: "",
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.postalCodeList.city,
                              callback: function ($$v) {
                                _vm.$set(_vm.postalCodeList, "city", $$v)
                              },
                              expression: "postalCodeList.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.regionType"),
                        prop: "areaType",
                        rules: [
                          {
                            required: true,
                            message: _vm.$t("collectionCenter.notNull"),
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                            filterable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.postalCodeList.areaType,
                            callback: function ($$v) {
                              _vm.$set(_vm.postalCodeList, "areaType", $$v)
                            },
                            expression: "postalCodeList.areaType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Capital", value: "Capital" },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "Metropolitana",
                              value: "Metropolitana",
                            },
                          }),
                          _c("el-option", {
                            attrs: { label: "Interior 0", value: "Interior 0" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Interior 1", value: "Interior 1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Interior 2", value: "Interior 2" },
                          }),
                          _c("el-option", {
                            attrs: { label: "Interior 3", value: "Interior 3" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("basicData.RiskAreas"),
                        prop: "riskArea",
                        rules: [
                          {
                            required: true,
                            message: _vm.$t("collectionCenter.notNull"),
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "collectionCenter.pleaseChoose"
                            ),
                            clearable: "",
                            filterable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.postalCodeList.riskArea,
                            callback: function ($$v) {
                              _vm.$set(_vm.postalCodeList, "riskArea", $$v)
                            },
                            expression: "postalCodeList.riskArea",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.yes"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.No"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "IBGE" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.postalCodeList.ibge,
                          callback: function ($$v) {
                            _vm.$set(_vm.postalCodeList, "ibge", $$v)
                          },
                          expression: "postalCodeList.ibge",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.addPostcode"),
                        prop: "postcode",
                        rules: [
                          {
                            required: true,
                            validator: _vm.validateZipCode,
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _vm.dialogTitle === _vm.$t("collectionCenter.add")
                        ? _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              rows: "6",
                              placeholder: _vm.$t(
                                "collectionCenter.postcodeFormatInstructions"
                              ),
                            },
                            model: {
                              value: _vm.postalCodeList.postcode,
                              callback: function ($$v) {
                                _vm.$set(_vm.postalCodeList, "postcode", $$v)
                              },
                              expression: "postalCodeList.postcode",
                            },
                          })
                        : _c("el-input", {
                            model: {
                              value: _vm.postalCodeList.postcode,
                              callback: function ($$v) {
                                _vm.$set(_vm.postalCodeList, "postcode", $$v)
                              },
                              expression: "postalCodeList.postcode",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "small" },
                  on: { click: _vm.cloceDialog },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submit },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.importTitle,
            visible: _vm.importIsOpen,
            width: "45%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importIsOpen = $event
            },
            close: _vm.cloceImportDialog,
          },
        },
        [
          _c("span", { staticClass: "import-title" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.uploadPostalCodeFile"))),
          ]),
          _c(
            "div",
            { staticClass: "upload-container" },
            [
              _c(
                "el-upload",
                {
                  ref: "demoUpload",
                  staticClass: "upload-demo",
                  attrs: {
                    "before-upload": _vm.beforeUpload,
                    "http-request": _vm.upLoad,
                    limit: 1,
                    action: "",
                    drag: "",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus",
                    staticStyle: {
                      margin: "25px auto 10px",
                      "font-size": "20px",
                    },
                  }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v(_vm._s(_vm.$t("collectionCenter.cldrUpload"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "font-size": "17px", margin: "20px 0 9px 50px" } },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.importTemplateDownload")))]
          ),
          _c(
            "div",
            {
              staticClass: "templateDownloadClass",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.templateDownload($event)
                },
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("collectionCenter.postalCodeTemplateDownload"))
                ),
              ]),
              _c("span", { staticClass: "el-icon-download" }),
            ]
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "small" },
                  on: { click: _vm.cloceImportDialog },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submitImportFile },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("GlobalSetObj.ImportResults"),
            visible: _vm.isImportResults,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isImportResults = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "margin-bottom": "20px" } },
            [
              _c("div", { staticStyle: { flex: "1" } }, [
                _vm._v(
                  _vm._s(_vm.$t("organizationManage.all")) +
                    "：" +
                    _vm._s(_vm.resultData.totalCount)
                ),
              ]),
              _c("div", { staticStyle: { flex: "1" } }, [
                _vm._v(
                  _vm._s(_vm.$t("organizationManage.succeed")) +
                    "：" +
                    _vm._s(_vm.resultData.successCount)
                ),
              ]),
              _c("div", { staticStyle: { flex: "1" } }, [
                _vm._v(
                  _vm._s(_vm.$t("operationCenter.fail")) +
                    "：" +
                    _vm._s(_vm.resultData.failCount)
                ),
              ]),
            ]
          ),
          _vm.resultData.errorFileUrl
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "10px",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("GlobalSetObj.ImportResults")) + "：")]
                ),
                _c(
                  "div",
                  { staticStyle: { color: "#00A551", cursor: "pointer" } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { "margin-right": "10px" },
                        on: { click: _vm.downloadError },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("collectionCenter.ImportPostcodeResult")
                          )
                        ),
                      ]
                    ),
                    _c("span", { on: { click: _vm.downloadError } }, [
                      _vm._v(_vm._s(_vm.$t("GlobalSetObj.Download"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.isImportResults = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }